import { render, staticRenderFns } from "./DeliveryTypeIcon.vue?vue&type=template&id=5cb55cec&"
import script from "./DeliveryTypeIcon.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports